
import Vue from 'vue';
import { Getter, Action } from 'vuex-class';
import Component from 'vue-class-component';
import NavBread from '../component/NavBread.vue';
import ProductDefect from './ProductDefect.vue';
import ProductConsultation from './ProductConsultation.vue';
import ProductProposal from './ProductProposal.vue';
import Foreign from './Foreign.vue';
import { Watch } from 'vue-property-decorator';
import { Message } from 'element-ui';

@Component({
  components: { NavBread, ProductConsultation, ProductProposal, ProductDefect,Foreign }
})
export default class FBForm extends Vue {
  @Getter feedbackResult: any;
  @Getter assignee: any;
  @Getter defaultAssignee: any;

  @Action getAssignee: Function;
  @Action getDefaultAssignee: Function;
  // 导航列表
  navData: any = [
    { name: '反馈中心', to: { path: '/feedback' } },
    { name: '我要反馈', to: { path: '/feedback/entrance' } }
  ];
  typeList: any[] = [
    { name: '产品咨询', type: 'consultation' },
    { name: '产品建议', type: 'proposal' },
    { name: '产品BUG', type: 'defect' },
    { name: '产品反馈', type: 'foreign' }
  ];
  type: string = '';

  created() {
    this.getAssignee();
    this.getDefaultAssignee();
    const type = this.$route.params.type;
    const info = this.typeList.find((item: any) => item.type === type);
    if (type && info) {
      this.type = type;
      this.navData.push({ name: info.name });
    } else {
      this.$router.push({ path: '/feedback/entrance' });
    }
  }

  // 提交成功后回调
  @Watch('feedbackResult.success', { deep: true })
  watchSubmitSuccess(newVal: boolean, oldVal: boolean) {
    if (newVal && newVal !== oldVal) {
      // 如果是外部调用
      if(this.type=='foreign'){
        Message.success("提交成功！");
        setTimeout(()=>{
          window.close();
        },1000);
       
      }
      
      setTimeout(() => {
        this.$router.push({
          path: '/feedback',
          query: { activeIndex: '2' }
        });
      }, 600);
    }
  }
}
